import { VIEW_COURSE_LOADING, VIEW_COURSE_SUCCESS, VIEW_COURSE_ERROR } from "../../../constant/actionTypes";

const viewCourseReducer = (state = {}, action) => {
    switch (action.type) {
        case VIEW_COURSE_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case VIEW_COURSE_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response,
            };
            return obj;
        }
        case VIEW_COURSE_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default viewCourseReducer;